import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import SharePageViaEmail from './SharePageViaEmail'
import { showShareViaEmailModal, hideShareViaEmailModal } from './actions'

const withShowShareViaEmailModal = withHandlers({
  handleShowShareViaEmailModal: ({ modalProps, showShareViaEmailModal }) =>
    () => showShareViaEmailModal(modalProps)
})

export default compose(
  connect(null, { showShareViaEmailModal, hideShareViaEmailModal }),
  withShowShareViaEmailModal
)(SharePageViaEmail)
